import { Bug, Sparkles } from 'lucide-react';
import { journalVisible, VERSION } from '../version';

const dateLongue = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long' });

/**
 * La version de l'application, et son journal.
 *
 * Le numéro se lit Majeure.Socle.Fonction.Correctif : la majeure attend le
 * passage en exploitation réelle, le socle compte les chantiers structurants,
 * la fonction les apports sur ce socle, le correctif les retouches. Le
 * journal descend du plus récent au plus ancien — on vient voir ce qui vient
 * de changer, pas relire les débuts.
 */
export default function JournalVersions() {
  // Le laboratoire lit le journal entier — c'est notre plan de travail.
  // L'espace d'un client ne montre que ce qui a tenu : nos étapes de mise au
  // point ne lui apprennent rien et donnent à lire des tâtonnements.
  const laboratoire =
    typeof window !== 'undefined' && window.location.hostname.startsWith('dev.');
  const livraisons = journalVisible(laboratoire);

  return (
    <div className="space-y-5">
      {/* Le numéro courant en évidence : c'est lui qu'on cite quand on
          signale un problème. */}
      <div className="rounded-xl bg-primary-50 dark:bg-primary-900/20 p-4 flex items-baseline gap-3 flex-wrap">
        <span className="text-3xl font-bold tabular-nums text-primary-800 dark:text-primary-200">
          {VERSION}
        </span>
        <span className="text-sm text-primary-700/80 dark:text-primary-300/80">
          Majeure · Socle · Fonction · Correctif — la majeure passera à 1 avec
          l'exploitation réelle.
        </span>
      </div>

      <ol className="relative border-l-2 border-gray-100 dark:border-gray-800 ml-2 space-y-6">
        {livraisons.map((v) => (
          <li key={v.version} className="pl-5 relative">
            {/* Le point d'ancrage sur la ligne de temps. */}
            <span
              className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full bg-primary-600 ring-4 ring-white dark:ring-gray-900"
              aria-hidden="true"
            />

            <div className="flex items-baseline gap-2 flex-wrap">
              <span className="font-mono font-semibold text-gray-900 dark:text-gray-100 tabular-nums">
                {v.version}
              </span>
              <span className="font-medium text-gray-800 dark:text-gray-200">{v.titre}</span>
              <span className="text-xs text-gray-500 dark:text-gray-400">
                {dateLongue.format(new Date(v.date))}
              </span>
            </div>

            <ul className="mt-1.5 space-y-1">
              {v.entrees.map((e, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400">
                  {e.type === 'feat' ? (
                    <Sparkles className="w-3.5 h-3.5 mt-0.5 shrink-0 text-primary-600" />
                  ) : (
                    <Bug className="w-3.5 h-3.5 mt-0.5 shrink-0 text-amber-600" />
                  )}
                  <span>{e.texte}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
}
